import { useEffect, useState } from 'react';
import bookingService from 'components/Booking-new/services/BookingService';
import { sortSlots } from '../utils/helpers/sortSlots';

export const useLocationTimeV3Slots = (
  locationServicePairs,
  desiredDays,
  desiredSlots,
  displayedItemCodes,
  notFetch,
) => {
  const [locationLoadingStatus, setLocationLoadingStatus] = useState({});
  const [error, setError] = useState(null);
  const [slotsPerLocation, setSlotsPerLocation] = useState({});

  useEffect(() => {
    if (notFetch) return;
    async function fetchAllTimeSlots() {
      setError(null);
      const newPairs = locationServicePairs.filter(pair => !displayedItemCodes.has(pair.locationCode));

      const newLoadingStatuses = newPairs.reduce((accum, pair) => {
        accum[pair.locationCode] = true;
        return accum;
      }, {});
      setLocationLoadingStatus(prevStatus => ({ ...prevStatus, ...newLoadingStatuses }));

      if (newPairs.length === 0) return;

      try {
        const response = await bookingService.getLocationTimeV3SeveralSlots(newPairs, desiredDays, desiredSlots);
        if (!response.error) sortSlots(response, setSlotsPerLocation);
        else setError(response.error);
      } catch (err) {
        setError(err.message);
      } finally {
        // set loading status to false for all newPairs
        const updatedStatuses = newPairs.reduce((accum, pair) => {
          accum[pair.locationCode] = false;
          return accum;
        }, {});
        setLocationLoadingStatus(prevStatus => ({ ...prevStatus, ...updatedStatuses }));
      }
    }

    if (locationServicePairs.length > 0) fetchAllTimeSlots();
  }, [locationServicePairs, desiredDays, desiredSlots, displayedItemCodes]);

  return { slotsPerLocation, locationLoadingStatus, error };
};
